module.exports = __webpack_public_path__ + "static/media/colorchart_deer.87321613.jpg";